var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-btn",
    _vm._g(
      _vm._b({ class: ["brb-btn"] }, "b-btn", _vm.attrs, false),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-center" },
        [
          _c(
            "div",
            { staticClass: "w-100", style: `opacity: ${_vm.loading ? 0 : 1}` },
            [_vm._t("default")],
            2
          ),
          _vm.loading
            ? _c(
                "b-spinner",
                _vm._b(
                  { staticClass: "position-absolute" },
                  "b-spinner",
                  _vm.loadingProps,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }